import {
  base64StringJsonFormat,
  booleanJsonFormat,
  objectJsonFormat,
  stringJsonFormat,
} from "@redotech/json/format";
import * as z from "zod/v4";

export const smsMessageMetadataSchema = z.object({
  teamId: z.string(),
  phoneNumber: z.string(),
  campaignId: z.string().optional(),
  automationId: z.string().optional(),
  automationStepId: z.string().optional(),
  templateId: z.string().optional(),
  category: z.string().optional(),
  isTest: z.boolean().optional(),
  recipientId: z.string().optional(),
  aiGenerated: z.boolean().optional(),
  marketingMessageId: z.string().optional(),
});

export type SmsMessageMetadata = z.infer<typeof smsMessageMetadataSchema>;

const _metadataFormat = objectJsonFormat<SmsMessageMetadata>(
  { teamId: stringJsonFormat, phoneNumber: stringJsonFormat },
  {
    campaignId: stringJsonFormat,
    automationId: stringJsonFormat,
    automationStepId: stringJsonFormat,
    templateId: stringJsonFormat,
    category: stringJsonFormat,
    recipientId: stringJsonFormat,
    isTest: booleanJsonFormat,
    aiGenerated: booleanJsonFormat,
    marketingMessageId: stringJsonFormat,
  },
);

export const metadataFormat = base64StringJsonFormat(_metadataFormat);
